//kpis
import { citiesDistributionConfig } from '@/lib/analytics/charts/facebook/citiesDistributionConfig';
import { countriesDistributionConfig } from '@/lib/analytics/charts/facebook/countriesDistributionConfig';
//charts
import { followersHistoryConfig } from '@/lib/analytics/charts/facebook/followersHistory';
import { gainedLostFollowersConfig } from '@/lib/analytics/charts/facebook/gainedLostFollowers';
import { followersConfig } from '@/lib/analytics/kpis/facebook/followers';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/facebook/followersEvolution';
import { gainedFollowersConfig } from '@/lib/analytics/kpis/facebook/gainedFollowers';
import { lostFollowersConfig } from '@/lib/analytics/kpis/facebook/lostFollowers';

export const CommunityFacebook = [
    // Line 1
    followersConfig,
    followersEvolutionConfig,
    gainedFollowersConfig,
    lostFollowersConfig,

    // Line 2
    followersHistoryConfig,
    gainedLostFollowersConfig,

    // Line 3
    countriesDistributionConfig,
    citiesDistributionConfig
];

export const requestFacebookParams = [
    // FacebookPageMetrics
    [
        'followers',
        'gained_followers',
        'lost_followers',
        'followers_history',
        'followers_evolution',
        'gained_lost_followers_history'
    ],
    // FacebookCommunity
    ['cities_distribution', 'countries_distribution']
];

export const requestFacebookOtherParameters = {
    countries_distribution: {
        type: countriesDistributionConfig.defaultFilter
    },
    cities_distribution: {
        type: citiesDistributionConfig.defaultFilter
    }
};
